/**
 * @module app.kya.edition.editionCtrl
 *
 * The let names witch contain "loading" mean : is a request pending ?
 */
define(['angular', 'moment'], function(angular, moment) {


    function EditionCtrl(
        $scope,
        $sce,
        $window,
        $location,
        $timeout,
        $log,
        $rootScope,
        Notification,
        $uibModal,
        editionService
    ) {
        let _editionService = editionService;
        let self = {};
        self.isUpdateLoading = false;

        self.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        };

        return self;
    }

    EditionCtrl.$inject = [
        '$scope',
        '$sce',
        '$window',
        '$location',
        '$timeout',
        '$log',
        '$rootScope',
        'Notification',
        '$uibModal',
        'editionService'
    ];

    angular
        .module('app.kya.edition.editionCtrl', ['ui.bootstrap', 'ui-notification'])
        .controller('EditionCtrl', EditionCtrl);
});
